import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import React, { useState, useEffect } from 'react';
// @mui
import {
  Card,
  Table,
  Stack,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  Tooltip,
} from '@mui/material';
// components
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
// sections
import { UserListHead } from '../sections/@dashboard/user';
// mock
import SteLib, {POPUP_INITDATA} from 'src/lib/stelib';
import { useParams } from 'react-router-dom';
import ShowBookPopup from 'src/components/stComponents/ShowBookPopup';
import CreateMovieBookingPopup from 'src/components/stComponents/CreateMovieBookingPopup';
import moment from 'moment';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  //{ id: 'id', label: 'Id', alignRight: false },
  { id: 'date', label: 'Data', alignRight: false },
  { id: 'time', label: 'Orario', alignRight: false },
  { id: 'availability', label: 'Disponibilità', alignRight: false },
  { id: '' },
];
// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis?.map((el) => el[0]);
}

export default function AdminMovieBookingsPage() {

  const [firstTime, setFirstTime] = useState(true);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [orderBy, setOrderBy] = useState('id');

  const [rowsPerPage, setRowsPerPage] = useState(50);

  const [movie, setMovie] = useState({})
  const [movieTimeTable, setMovieTimeTable] = useState({})

  const [openEdit, setOpenEdit] = useState(false);
  const [editData, setEditData] = useState(undefined);
  const params = useParams();

  const [SBP_data, SBP_setData] = useState(POPUP_INITDATA);

  useEffect(() => {
    if(firstTime)
    {
      getMovieTimeTable();
    }
    setFirstTime(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [firstTime]);
  
  let showBooking = (title, timeTableId, refresh) => {
    if(refresh)
    {
      SBP_setData({...POPUP_INITDATA, open: false});
    }
    SteLib.GetRequest("timetables/"+timeTableId, {}, false).then((data) => {
      SBP_setData({...SBP_data, open: true, title: title, timeTable: data});
    });

  }

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const getMovieTimeTable = () => {
    SteLib.GetRequest("movies/"+params.id, {}, {}).then((data) => {
      let timeTable = [];
      if(data.timeTable !== undefined)
      {
        data.timeTable.map(tt => {
          tt.slots.map(slot => {
            timeTable.push({
              "id": slot.id,
              "title": data.title,
              "date": tt.date,
              "time": slot.time,
              "availability": slot.availability,
              "bookable": slot.bookable,
              "expired": moment(tt.date + " " + slot.time, "YYYY-MM-DD HH:mm:ss") < moment()
            })
            return true;
          })
          return true;
        })
      }
      setMovieTimeTable(timeTable);
      setMovie(data);
    });
  }

  //getUser();

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - movieTimeTable.length) : 0;

  const filteredMovieTimetable = applySortFilter((movieTimeTable?.length ?? 0) > 0 ? movieTimeTable : [], getComparator(order, orderBy), "");

  let deleteTimetable = (id) => {
    if(id > 0)
    {
      if(window.confirm("Sei sicuro?"))
      {
        SteLib.DeleteRequest("timetables/"+id, {}, false).then((data) => {
          getMovieTimeTable();
        });
      }
    }
  }

  let printReport = (id) => {
    if(id > 0)
    {
      SteLib.FileRequestDownload("timetables/"+id+"/report").then((data) => {
        
      });
    }
  }
  

  let changeBookableStatus = (id) => {
    if(id > 0)
    {
      if(window.confirm("Confermi cambio blocco prenotabilità?"))
      {
        SteLib.PutRequest("timetables/"+id+"/invertBookable", {}, false).then((data) => {
          getMovieTimeTable();
        });
      }
    }
  }

  return (
    <>
      <Helmet>
        <title> Gestisci proiezioni </title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Gestisci proiezioni <br/>
            <u><small>{movie?.title}</small></u>
          </Typography>
          <CreateMovieBookingPopup movieId={movie?.id} setOpenEdit={setOpenEdit} openEdit={openEdit} editData={editData} setEditData={setEditData} successCallback={getMovieTimeTable}/>
        </Stack>

        <Card>
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={movieTimeTable?.length}
                  onRequestSort={handleRequestSort}
                />
                <TableBody>
                  {filteredMovieTimetable?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                    const { id, title, date, time, availability, bookable, expired } = row;

                    return (
                      <TableRow hover key={id} tabIndex={-1}>
                        {<>&nbsp;</>}

                        <TableCell component="th" scope="row" padding="none">
                          <Stack direction="row" alignItems="center" spacing={2}>
                            {/*<Avatar alt={name} src={avatarUrl} />*/}
                            <Typography variant="subtitle2" noWrap>
                            {SteLib.FormatDMY(date)}
                            </Typography>
                          </Stack>
                        </TableCell>

                        <TableCell align="left">{SteLib.FormatHHMM(time)}</TableCell>

                        <TableCell align="left">{availability}</TableCell>

                        <TableCell align="right">
                          <IconButton sx={{color: bookable ? expired ? '#f57c00' : 'success.main' : expired ? '#f57c00' : '#fbc02d'}}
                              onClick={() => !expired ? changeBookableStatus(id) : () => {}}>
                              <Tooltip title={expired ? "Proiezione Scaduta" : bookable ? "Prenotabile" : "Non prenotabile"}>
                                <Iconify icon={bookable ? expired ? 'mdi:lock-open-alert-outline' : 'mdi:lock-open-outline' : expired ? 'mdi:lock-alert-outline' : 'mdi:lock-outline'} />
                              </Tooltip>
                          </IconButton> 
                          <IconButton onClick={() => showBooking(title, id)}>
                            <Iconify icon={'mdi:seat'} />
                          </IconButton>
                          <IconButton sx={{color: '#6a1a77'}} onClick={() => printReport(id)}>
                            <Iconify icon={'eva:printer-outline'} />
                          </IconButton>
                          <IconButton sx={{color: 'error.main'}} onClick={() => deleteTimetable(id)}>
                            <Iconify icon={'eva:trash-2-outline'} />
                          </IconButton>
                          
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[25, 50, 100]}
            component="div"
            count={movieTimeTable?.length ?? 0}
            rowsPerPage={rowsPerPage}
            page={page}
            labelRowsPerPage='Righe per pagina:'
            labelDisplayedRows={({ from, to, count }) => `${from}-${to} di ${count}`}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>
      <ShowBookPopup state={{data: SBP_data, setData: SBP_setData}} successCallback={() => {showBooking(SBP_data.title, SBP_data.timeTable.id, true);}}></ShowBookPopup>
    </>
  );
}
